import { createContext, useContext, useState } from 'react';

const ConfirmContext = createContext();

export const ConfirmProvider = ({ children }) => {
  const [confirm, setConfirm] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });

  const showConfirm = ({ title = 'Konfirmasi', message, onConfirm }) => {
    setConfirm({
      show: true,
      title,
      message,
      onConfirm
    });
  };

  const handleClose = () => {
    setConfirm({
      show: false,
      title: '',
      message: '',
      onConfirm: null
    });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) {
      confirm.onConfirm();
    }
    handleClose();
  };

  return (
    <ConfirmContext.Provider value={{ showConfirm }}>
      {children}

      {confirm.show && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="col-md-4 modal-content">
              <div className="modal-header">
                <h6 className="modal-title">{confirm.title}</h6>
              </div>

              <div className="modal-body text-center">
                {confirm.message}
              </div>

              <div className="modal-footer text-center">
                <button
                  className="btn btn-secondary btn-sm"
                  style={{width: "80px"}}
                  onClick={handleClose}
                >
                  Batal
                </button>
                {/*<span style={{width: "20px"}}/>*/}
                <button
                  className="btn btn-danger btn-sm"
                  style={{width: "80px"}}
                  onClick={handleConfirm}
                >
                  Ya
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
